import { assign, some } from 'lodash';
export const getUpdatedCurrentDevices = (devices, current) => {
    const update = {};
    if (!some(devices, (dev) => dev.deviceId == current.cameraId)) {
        assign(update, { cameraId: null, facingMode: null });
    }
    if (!some(devices, (dev) => dev.deviceId == current.microphoneId)) {
        assign(update, { microphoneId: null });
    }
    if (!some(devices, (dev) => dev.deviceId == current.speakerId)) {
        assign(update, { speakerId: null });
    }
    return update;
};
